export const API_URL = 'https://api-crm2.technext.ao/api';